import React, { useContext } from 'react';

/**
 * Props for Provider
 * @typedef {Object} ReviewsContextProps
 * @property {boolean} withLinkToGig
 * @property {{name: string; rate: number; symbol: string; template: string}} currencyConfig
 * @property {boolean} enableSearchFilter
 * @property {boolean} enableReliableReviews
 * @property {boolean} shouldAllocateForReliableReviews
 * @property {boolean} reliableReviewsKillswitch
 * @property {string} translationUrl
 * @property {boolean} displayPurchasedGig
 * @property {boolean} isReviewItemFullWidth
 */

/**
 * Values for consumers
 * @typedef {ReviewsContextProps} ReviewsContextData
 */

/** @type {React.Context<ReviewsContextData | undefined>} */
export const ReviewsContext = React.createContext({
    withLinkToGig: true,
    enableSearchFilter: false,
    translationUrl: null,
    displayPurchasedGig: false,
    isReviewItemFullWidth: false,
});

/** @type {() => ReviewsContextData} */
export const useReviewsContext = () => useContext(ReviewsContext);

/** @type {React.FC<ReviewsContextProps>} */
export const ReviewsContextProvider = ({
    initialState,
    children,
    currencyConfig,
    withLinkToGig,
    enableSearchFilter,
    translationUrl,
    displayPurchasedGig,
    isReviewItemFullWidth,
}) => (
    <ReviewsContext.Provider
        value={{
            initialState,
            currencyConfig,
            withLinkToGig,
            enableSearchFilter,
            translationUrl,
            displayPurchasedGig,
            isReviewItemFullWidth,
        }}
    >
        {children}
    </ReviewsContext.Provider>
);
